import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
interface HeaderProps {
  onScrollToCatalog?: () => void;
  onBusinessOrder?: () => void;
  onBookTable?: () => void;
  onJobs?: () => void;
}
export function Header({
  onScrollToCatalog,
  onBusinessOrder,
  onBookTable,
  onJobs
}: HeaderProps) {
  return <header className="w-full pt-12 pb-20 md:pt-16 md:pb-32 flex flex-col items-center px-4" data-id="element-594" data-mp="2nm5224416h5b">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="relative w-full max-w-[500px] mb-10" data-id="element-595" data-mp="2rlma95audse6">
        <img src="https://cdn.magicpatterns.com/uploads/qmwBa2tP2vciePEfbWYRRk/top_notch_logga.png" alt="Top Notch Bakery Logo" className="w-full h-auto object-contain drop-shadow-sm" data-id="element-596" data-mp="36aa3h4x7tq0y" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2,
      ease: 'easeOut'
    }} className="text-center mb-12 md:mb-14 max-w-4xl px-2 sm:px-4" data-id="element-597" data-mp="2wkkydbxg5m38">
        <p className="font-serif text-[1.75rem] leading-[1.25] sm:text-4xl md:text-5xl md:leading-[1.15] text-[#1A1A1A] tracking-tight" data-id="element-598" data-mp="2hovgnpzanv4b">
          Hos oss hittar du nybakat bröd, kreativa bakverk och vällagad mat –{' '}
          <em className="italic text-[#7C8062]" data-id="element-599" data-mp="3ad11ecqclk45">alltid gjort från grunden.</em>
        </p>
        <div className="mx-auto mt-7 md:mt-9 w-12 h-px bg-[#C4993D]" data-id="element-600" data-mp="35jy4pvq9xujq" />
        <p className="mt-7 md:mt-9 mx-auto max-w-2xl text-lg md:text-xl leading-relaxed text-[#1A1A1A]/75" data-id="element-601" data-mp="30lel41z5kuuj">
          Vi drivs av{' '}
          <span className="font-serif italic text-[#1A1A1A]" data-id="element-602" data-mp="1xqxcz2we4tq">nyfikenhet</span>,{' '}
          <span className="font-serif italic text-[#1A1A1A]" data-id="element-603" data-mp="3t9k7et5uurwh">
            hantverksskicklighet
          </span>{' '}
          och en genuin{' '}
          <span className="font-serif italic text-[#C4993D]" data-id="element-604" data-mp="1wceh89icv8zo">
            kärlek till det vi skapar
          </span>
          .
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center gap-5 w-full max-w-2xl mb-20 md:mb-32" data-id="element-605" data-mp="1hnhzfkqhyhlv">
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full justify-center" data-id="element-606" data-mp="ypfepi4zf6tv">
          <button onClick={onScrollToCatalog} className="w-full sm:w-auto px-8 py-3.5 bg-[#C4993D] text-[#F2EDE4] rounded-full font-medium text-sm hover:bg-[#A8832F] transition-colors shadow-sm" data-id="element-607" data-mp="13ngy646bl85v">
            Förbeställning Privat
          </button>
          <button onClick={onBusinessOrder} className="w-full sm:w-auto px-8 py-3.5 bg-transparent border-2 border-[#C4993D] text-[#C4993D] rounded-full font-medium text-sm hover:bg-[#C4993D]/10 transition-colors" data-id="element-608" data-mp="meo7h9pr1no2">
            Företagsbeställning
          </button>
          <button onClick={onBookTable} className="w-full sm:w-auto px-8 py-3.5 bg-[#7C8062] text-[#F2EDE4] rounded-full font-medium text-sm hover:bg-[#6A6D53] transition-colors shadow-sm" data-id="element-609" data-mp="rdr9elafndrt">
            Boka Bord
          </button>
        </div>
        <button onClick={onJobs} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-transparent border-2 border-[#7C8062] text-[#7C8062] rounded-full font-medium text-sm hover:bg-[#7C8062] hover:text-[#F2EDE4] transition-colors" data-id="element-610" data-mp="1085skyy338g7">
          <Briefcase className="w-4 h-4" data-id="element-611" data-mp="3gwt4ak1r1y1n" />
          Jobba hos oss
        </button>
      </motion.div>

      {/* Editorial Image Grid */}
      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start" data-id="element-612" data-mp="22z6v4fh3gdh8">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="w-full" data-id="element-613" data-mp="27x8lzmkrhh39">
          <img src="https://cdn.magicpatterns.com/uploads/fKFpEdf5PFAj8HiGFNH4Ae/0AC39895-57D5-4F1D-BFC8-B4D1341FF8F6.png" alt="Top Notch Bakery Counter" className="w-full aspect-[3/4] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-614" data-mp="1k9gydmtrthmo" />
        </motion.div>

        <div className="w-full flex flex-col gap-6 md:gap-8 md:mt-16" data-id="element-615" data-mp="1y0vmg82jc90l">
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.8,
          ease: 'easeOut'
        }} data-id="element-616" data-mp="11gmsrji1f1v4">
            <img src="https://cdn.magicpatterns.com/uploads/fydJovVoiB1VDRERSZCu7c/77E18535-8EC5-4A5D-842C-07BE6F7121F8.png" alt="Top Notch Bakery Chocolate Display" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-617" data-mp="t1gy8g9l6mn1" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 1.0,
          ease: 'easeOut'
        }} data-id="element-618" data-mp="aafvdh5ci6y7">
            <img src="https://cdn.magicpatterns.com/uploads/uqyo82xEXsx7htA4oPJVbw/8D11E304-9909-41BA-83B2-2DFA1C7F7BBD.png" alt="Top Notch Bakery Kanelbullar & Munkar" className="w-full aspect-[4/3] object-cover rounded-2xl shadow-lg border border-[#7C8062]/10" data-id="element-619" data-mp="3serdugjozvkh" />
          </motion.div>
        </div>
      </div>
    </header>;
}